import { lazy, Suspense, type ComponentProps } from "react";

// The exporter brings a zip writer and HTML→Markdown/ENEX converters; load them only when someone exports.
const Dialog = lazy(() => import("./Exporter").then((m) => ({ default: m.ExportDialog })));

export function ExportDialog(props: ComponentProps<typeof Dialog>) {
  return (
    <Suspense fallback={null}>
      <Dialog {...props} />
    </Suspense>
  );
}
